import { FormFieldProps } from 'ui/formField';
import { BasicSelect, SelectProps } from 'ui/selects';
import { StyledFormField } from '../SmsSmartOptIn.styled';

type Props = Pick<FormFieldProps, 'errorText' | 'hasError' | 'helpText' | 'labelText'> &
  Pick<SelectProps, 'id' | 'defaultValues' | 'options' | 'onSelect'>;

export const BasicSelectFormField = ({
  id,
  defaultValues,
  errorText,
  hasError,
  helpText,
  labelText,
  options,
  onSelect,
}: Props) => {
  return (
    <StyledFormField
      data-test={id}
      errorText={errorText}
      hasError={hasError}
      helpText={helpText}
      labelText={labelText}
    >
      <BasicSelect
        defaultValues={defaultValues}
        id={`${id}-select`}
        onSelect={onSelect}
        options={options}
        style={{ display: 'block' }}
        isFullWidth
      />
    </StyledFormField>
  );
};
